"use strict";

import { toggleSpinner } from './utils/appSpinner';

require('babel-polyfill');
require('./utils/customPolyfill');

window.ReactI18n = require('react-i18next');

/** React and Flux*/
window.React = require('react');
window.ReactDOM = require('react-dom');
window.ReactRouter = require('react-router');
window.EventEmitter = require('events').EventEmitter;

/** Common libs*/
window.keyMirror = require('fbjs/lib/keyMirror');
window.assign = require('object-assign');
window.classnames = require('classnames');

window.i18n = require('./i18next');
window.withTranslate = require('./decorators/withTranslate').withTranslate;
var Esk = {};
window.Esk = Esk;

Esk.PropTypes = require('./utils/propTypes.js');

//base app config init
Esk.Constants = require('./constants');
Esk.Config = require('./config');
Esk.Utils = require('./utils');
require('./config/momentConfig');

//app data init
Esk.AppDispatcher = require('./dispatcher/appDispatcher');
Esk.Action = {
  AppAction: require('./action/appAction'),
  NewsAction: require('./action/newsAction'),
  MiscueSessionsAction: require('./action/miscueSessionsAction')
};

//app views init
Esk.Helper = require('./helper');

var AppRouter = require('./routes');
var AppContext = require('./appContext');

var I18nextProvider = ReactI18n.I18nextProvider;

ReactDOM.render((
  <I18nextProvider i18n={ i18n }>
    <AppContext toggleGlobalSpinner={toggleSpinner}>
			{AppRouter}
    </AppContext>
  </I18nextProvider>
), document.getElementById('app'));

